import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Github, Linkedin, ExternalLink, ArrowUpRight } from 'lucide-react';
import { profile } from '../data/profile';
import Magnetic from './Magnetic';
import TextReveal from './TextReveal';
import XIcon from './XIcon';
import './Contact.css';

const Contact = () => {
  return (
    <section className="section contact" id="contact">
      <div className="container">
        <motion.div
          className="contact__card glass gradient-border gradient-border--on"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="eyebrow">Contact</span>
          <TextReveal as="h2" className="section-title" text="Let's build something" mode="words" inView />
          <p className="contact__text">
            Got an idea, a role, or a hackathon team that needs a builder? The fastest way to
            reach me is email.
          </p>

          <Magnetic strength={0.25}>
            <a href={profile.socials.email} className="btn btn-primary contact__email">
              <Mail size={18} /> {profile.email}
            </a>
          </Magnetic>

          <div className="contact__links">
            <a href={profile.socials.github} target="_blank" rel="noreferrer" className="contact__link">
              <Github size={17} /> GitHub <ArrowUpRight size={14} />
            </a>
            <a href={profile.socials.x} target="_blank" rel="noreferrer" className="contact__link">
              <XIcon size={15} /> X <ArrowUpRight size={14} />
            </a>
            <a href={profile.socials.linkedin} target="_blank" rel="noreferrer" className="contact__link">
              <Linkedin size={17} /> LinkedIn <ArrowUpRight size={14} />
            </a>
            <a href={profile.socials.devpost} target="_blank" rel="noreferrer" className="contact__link">
              <ExternalLink size={17} /> Devpost <ArrowUpRight size={14} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
